module.exports = __webpack_public_path__ + "static/media/menu-team.926e0d21.svg";